import { Component, EventEmitter, OnInit, ViewEncapsulation, Input, Output, OnChanges, HostListener, HostBinding, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import { parse } from 'url';
import { SuggestDiagnosisService } from './../services/suggest-diagnosis.service';

@Component({
  selector: 'app-diagnosis-results',
  templateUrl: './diagnosis-results.component.html',
  styleUrls: ['./diagnosis-results.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class DiagnosisResultsComponent implements OnInit, OnChanges {
  private _diagnosis = '';
  private _whereToQueryParams = '';
  filterSymptoms: String;
  switchFilterActive: Array<Boolean>;
  @Output() onClickSymptomDetails = new EventEmitter<Object>();
  @Output() onClickFilerResults = new EventEmitter<Object>();

  @Input()
  set diagnosis(diagnosis: any){
      this._diagnosis = diagnosis;
  }

  get diagnosis(): any{
    return this._diagnosis;
  }
  currentfilterActive: String;

  // @Input()
  // set whereToQueryParams(whereToQueryParams: any){
  //     this._whereToQueryParams = whereToQueryParams;
  // }

  // get whereToQueryParams(): any{
  //   return this._whereToQueryParams;
  // }

  @Input() whereToQueryParams: any;
  @Input()  loadingStyle: any ;
  @Input()  loadingSpinnerStyle: any ;
  @HostBinding('attr.role') role = 'admin';
  @HostListener('click') onClick() {
   // this.role=this.role=='admin'?'guest':'admin';
  }

  public onResize() {
    // console.log('windowresized');
  }
  constructor(
    private router: Router,
    private SuggestDiagnosisService: SuggestDiagnosisService,
  ) {
    this.diagnosis = [];
    this.filterSymptoms = 'top10';
    this.switchFilterActive = [true, false, false, false];
   }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
  }

  public displaySymptoms(filterActive: number, value: string): void {
    this.filterSymptoms = value;
    this.switchFilterActive = [false, false, false, false];
    this.switchFilterActive[filterActive] = true;
    this.onClickFilerResults.emit(value);
    if (filterActive === 2 && value === 'redflags') {
      this.currentfilterActive = value;
    } else {
      this.currentfilterActive = undefined;
    }
    // console.log(value);
  }

  public onKnowledgeWindow(value: string): void {
      const kURL = parse(value, true);
      this.router.navigate(['/knowledge-window'], { queryParams: kURL.query });
      // console.log(kURL);
      // this.router.navigate(['/where-to-go-tool' + encodeURIComponent(value)]);
  }

  onSymptomDetails(chunkID: String, symptomName: String) {
    const symptomDetails = {
      'chunkID': chunkID,
      'symptomName': symptomName
    };
    this.onClickSymptomDetails.emit(symptomDetails);
    this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS DETAILS', symptomName);
  }

  public onWhereNow(): void {
    // console.log(this.whereToQueryParams);
    if (this.whereToQueryParams !== undefined) {
      this.router.navigate(['/where-to-go-tool'], { queryParams: this.whereToQueryParams });
    }
  }

  public onWindowPrint(): void {
    window.print();
  }
}



// WEBPACK FOOTER //
// ./src/app/diagnosis-results/diagnosis-results.component.ts